import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { initAuth } from './auth';
import { App } from './App';
import './styles.css';
import { applyTheme } from './theme';

applyTheme();

const root = createRoot(document.getElementById('root')!);

initAuth()
  .then(() =>
    root.render(
      <StrictMode>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </StrictMode>,
    ),
  )
  .catch((e) => root.render(<div className="center-msg">Aplicația nu poate porni: {String(e.message ?? e)}</div>));
